// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index.js";
import axios from "axios";
import Vant, { Dialog } from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/resetui.css'
import Qs from "qs";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'babel-polyfill'
import PinchZoom from 'vue-pinch-zoom';
import JSONbig from "json-bigint"
import {description} from "./../package.json"
Vue.component('pinch-zoom', PinchZoom);

Vue.use(Vant);
Vue.use(VueMoment, {
  moment,
});

Vue.config.productionTip = false;
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse = [(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];
// const host = process.env.NODE_ENV === "development" ? "http://api.stock.com/" : "https://pc_apiserver5618.hk9999.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境

// Dedicated axios instance for line reachability checks
const lineCheckHttp = axios.create({
  timeout: 1500,
  withCredentials: false,
  validateStatus: () => true,
  // Bypass global transforms for lightweight ping
  transformRequest: [data => data],
  transformResponse: [data => data]
});

// add public key encryption code when no key in local storage
let encriptPublicKey = localStorage.getItem('encript_public_key');

if (!encriptPublicKey){
  localStorage.setItem('encript_public_key', process.env.PUBLIC_ENCRYPTION_KEY);
}

console.log("build :",description);
let initApp = function () {
  console.log('initApp',localStorage.getItem('lineUrl'));
  const instance = axios.create({
    baseURL: localStorage.getItem('lineUrl') ? localStorage.getItem('lineUrl') : window.__env.API_ROOT,
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$http = instance;

  // sessionStorage.removeItem('lineUrl')
  /**
     * wonder chat system start
     */
  const wonderChatInstace = axios.create({
   baseURL: localStorage.getItem('chat_api'),
    timeout: 10000,
    withCredentials: true
  });
  Vue.prototype.$wonderChat = wonderChatInstace;
  
    //end wonder chat system
    //Vue.prototype.$http = instance;
  
    //force logout and goto login
    Vue.prototype.$logout = function (msg) {
      this.$toast.fail(msg);
      setTimeout(() => {
        this.$store.commit("changeLoginType", false);
        sessionStorage.setItem("token", "");
        localStorage.clear();
        this.$router.push("/login");
        window.location.reload();
      }, 2000);
    };
  
    // Common loader
    Vue.prototype.$NoNetworkErrorMsg = "网络连接失败,稍后再试";
    Vue.prototype.$ShowCommonLoading = function () {
      return this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: "加载中...",
      });
    };
    // const host = process.env.NODE_ENV === "development" ? "/" : "https://server.hk9999z.com/"; // 根据 process.env.NODE_ENV 的值判断当前是什么环境
    // const instance = axios.create({
    //   baseURL: host,
    //   timeout: 10000,
    //   withCredentials: true
    // });
    // Vue.prototype.$http = instance;
    // 添
    /* eslint-disable no-new */
  // Vue.prototype.$http.interceptors.request.use(
  //   (config) => {
  //     const platformkey = "DNZQ";
  //     const accessToken = "SjWPTvAutn3WdVVMuOaGcqyIZFyHe2SUzoPaLDLYQaA"

  //     // set header for every request
  //     config.headers['Platform-Key'] = platformkey;
  //     config.headers['Authorization'] = accessToken;

  //     return config;
  //   },
  //   (error) => Promise.reject(error)
  // );

  
    Vue.prototype.$LoadFromDomain = process.env.LOAD_FROM_DOMAIN;
    Vue.prototype.$AutoLogin = process.env.AUTO_LOGIN;
    Vue.prototype.$DownloadPopup = process.env.DOWNLOAD_POPUP;
    Vue.prototype.$VersionUpdateNotify = process.env.VERSION_UPDATE_NOTIFY;
  
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    });
 
    router.afterEach((to, from, next) => {
     window.scrollTo(0, 0);
   });
}


Vue.prototype.$chatApiURL = localStorage.getItem('chat_api');//"https://chat.hk99555.com/";

let Line_1 = window.__env.Line_1;//"https://server3299.hk99666.com/";
let Line_2 = window.__env.Line_2;//"https://server3299.hk99111.com/";

Vue.prototype.$URLs = [{ "id": 1, "name": "线路 1", "url": window.__env.API_ROOT, temp: false }, { "id": 2, "name": "线路 2", "url": Line_1, temp: false }, { "id": 3, "name": "线路 3", "url": Line_2, temp: false  }];

//if the build version is greater than the local storage build version, then update the api lines
console.log('build version:',description, 'local storage build version:',localStorage.getItem('build_version'));

if(parseInt(description) > parseInt(localStorage.getItem('build_version')) || !localStorage.getItem('build_version')){
  localStorage.setItem('api_lines', JSON.stringify(Vue.prototype.$URLs));
  localStorage.setItem('build_version', description);
}



// Remove duplicate urls from Vue.prototype.$URLs (keep first occurrence)
(function () {
  if (Array.isArray(Vue.prototype.$URLs)) {
    const urlSet = new Set();
    Vue.prototype.$URLs = Vue.prototype.$URLs.filter(item => {
      if (item && item.url && !urlSet.has(item.url)) {
        urlSet.add(item.url);
        return true;
      }
      return false;
    });
  }
})();


let lines = JSON.parse(localStorage.getItem('api_lines') || '[]');



// 检查 api_lines 列表中 url 是否有重复项，如果有则移除重复项（保留第一个）



if(lines.length === 0){
  lines = Vue.prototype.$URLs;
  localStorage.setItem('api_lines', JSON.stringify(lines));
}else{
  if (Array.isArray(lines) && lines.length > 0) {
    const seen = new Set();
    lines = lines.filter(item => {
      if (item && item.url && !seen.has(item.url)) {
        seen.add(item.url);
        return true;
      }
      return false;
    });
    localStorage.setItem('api_lines', JSON.stringify(lines));
  }
}
let checkLine = function (url) {
  return new Promise((resolve, reject) => {
   if(url === null || url === undefined){reject();return;};
    lineCheckHttp.get(url).then(() => {
      console.log('line working inside checkLine',url);
      resolve();
    }).catch((e) => {
      console.log('line not working inside checkLine',url,e);
      reject();
    });
  });
}

let workingLines = [];


let lineSelectPromise = new Promise((resolve) => {
  (async () => {
    const list = Array.isArray(lines) ? lines : [];
    for (const value of list) {
      if (!value || !value.url) continue;

      const startTime = Date.now();
      try {
        // Optional inline timeout (4s):
        // const controller = new AbortController();
        // await Promise.race([
        //   fetch(value.url, { mode: 'no-cors', signal: controller.signal }),
        //   new Promise(r => setTimeout(() => { controller.abort(); r(); }, 4000))
        // ]);

        await fetch(value.url, { mode: 'no-cors' }); // wait for this one to finish
        const elapsedTime = Date.now() - startTime;
        if (!workingLines.some(l => l.url === value.url)) {
          workingLines.push({ url: value.url, time: elapsedTime });
        }
      } catch (e) {
        // ignore failures, move to next
      }
    }
    resolve(workingLines);
  })();
});
  
  //continue with current api line if it's working
 let storedLine = localStorage.getItem('lineUrl');
 console.log('storedLine',storedLine);

 

  checkLine(storedLine).then(() => {
    localStorage.setItem('lineUrl', storedLine);
    //check if there is a temp line that is not the stored line
    let storedLineItem = lines.find(item => item.url !== storedLine && item.temp);
    if(storedLineItem){
      //remove temp lines
      lines = lines.filter(item => !item.temp);
      localStorage.setItem('api_lines', JSON.stringify(lines));
    }
    initApp();
  }).catch(() => {
    (async () => {
      console.log("current line not workin");
      const list = Array.isArray(lines) ? lines : [];
      let selected = null;
      let measured = [];
      for (const item of list) {
        if (!item || !item.url) continue;
        const start = Date.now();
        try {
          await checkLine(item.url); // wait for each check before moving on
          measured.push(item);
          selected = item.url;
          console.log('line working', item.url);
          break;
        } catch (e) {
          console.log('line not working', item.url);
        }
      }
      if (selected) {
        localStorage.setItem('lineUrl', selected);
        if (measured.length > 0) {
          localStorage.setItem('api_lines', JSON.stringify(measured));
        }
        initApp();
      } else {
        localStorage.setItem('lineUrl', window.__env.API_ROOT);
        initApp();
        Dialog.alert({
          title: "线路异常",
          message: "网络状态异常， 请尝试切换线路。",
          confirmButtonText: "切换线路",
        }).then(() => {
          router.push('/api_line_selector');
        });
      }
    })();
  });




// WEBPACK FOOTER //
// ./src/main.js